export default __webpack_public_path__ + "static/NuvemFiscalNFCe-eaf9a99f708190e6cb1d9f0b0d54006d.png";